module.exports = __webpack_public_path__ + "static/media/gmdm.22aeb82d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/en/gmdm.png
// module id = 129
// module chunks = 0